import uniqid from 'uniqid'

const generateSessionId = (): string => uniqid()

export default generateSessionId
